import { render, staticRenderFns } from "./NoticePageApp.vue?vue&type=template&id=e1a27f9c"
import script from "./NoticePageApp.vue?vue&type=script&lang=js"
export * from "./NoticePageApp.vue?vue&type=script&lang=js"
import style0 from "./app.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports